import React, { useEffect, useState } from 'react'
import { Alert } from 'components'
import { UploadFile } from 'components/Form'
import { Space } from 'styles/GlobalStyle'
import { schoolHooks } from '.'
import { updateOrCreateTestTakersFetch } from 'store/middlewares/testTakers.crud'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { useMutation } from '@tanstack/react-query'

const DownloadStudentFileAlert = ({ props }) => {
    const [file, setFile] = useState(null)

    const downloadStudentFileAlert = schoolHooks.useDownloadStudentFileAlert()

    const { mutateAsync: uploadFile, isPending: createTestTakerLoading } = useMutation({
        mutationFn: updateOrCreateTestTakersFetch,
        onSuccess: (res) => {
            toast("התלמידים התווספו בהצלחה", toastConfig)
        }
    })

    const submitBtns = [{ color: "thirdly", label: "שמירה", action: uploadFile }]

    return (
        <Alert
            width={700}
            systemUI
            title={"הורדת קובץ תלמידים"}
            footerActions={[]}
            handleAlert={() => downloadStudentFileAlert(false)}
        >
            <div>
                {"קובץ התלמידים בפורמט GO יורד ריק,"}
            </div>
            <div>
                {"עליכם למלא את פרטי התלמידים ולעלות אותו חזרה לתוך הכיתה שברצונכם להוסיף"}
            </div>
            <div>
                <b>חשוב לא לשנות את שם הקבץ, או את שמות העמודות!</b>
            </div>
            {/* <Space />
            <UploadFile
                type="exel"
                showCleanIcon={true}
                input={{
                    value: file,
                    onChange: setFile
                }}
            /> */}
        </Alert>
    )
}

export default DownloadStudentFileAlert